import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFuelTotalsReport extends Layout {
    daterangefilter1: Textbox;
    sourceFuelTotalsConfigured: DataSource;
    textboxFuelInterfaceId: Textbox;
}
